<button
  type="button"
  class="lum-button lum-button--secondary"
  (click)="open()"
  [disabled]="disabled"
>
  Connect WMS
</button>
